<template>
  <div>
    <div>
      If a rock is sized and perfectly weighted,
      it is absolutely the best way to safely crush and peel garlic cloves
    </div>
    <div class="secondary-font">
      No sharp edges to cut yourself on | No nooks and crannies
      that are difficult to clean
    </div>
    <div class="video">
      <iframe
        src="https://www.youtube.com/embed/TpdlJVNZRxI"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>
    <div class="secondary-font">Multiple colors and sizes to choose from!</div>
    <carousel>
      <slide>
        <v-lazy-image
          srcset="https://firebasestorage.googleapis.com/v0/b/garlic-rock.appspot.com/o/JPG%2Fsimple_demo.jpg?alt=media&token=df7ca3f4-3baa-44ab-a8f1-21ce1c4e3932"
          alt="Hand holding a well sized rock for crushing garlic"
          use-picture
        >
          <source
            type="image/webp"
            srcset="https://firebasestorage.googleapis.com/v0/b/garlic-rock.appspot.com/o/WebP%2Fsimple_demo.webp?alt=media&token=da1c94a3-5b11-48a6-9ffc-988eb93306fe"
          />
          <source
            type="image/jp2"
            srcset="https://firebasestorage.googleapis.com/v0/b/garlic-rock.appspot.com/o/JPEG2000%2Fsimple_demo.jp2?alt=media&token=f5e05018-29ae-4c4d-8564-46ab9fe4ea6e"
          />
        </v-lazy-image>
      </slide>
      <slide>
        <v-lazy-image
          data-src="https://firebasestorage.googleapis.com/v0/b/garlic-rock.appspot.com/o/JPG%2Fsmashing_garlic_demo.jpg?alt=media&token=0ee95543-2243-480e-bfbf-84079ec02480"
          alt="Rock being smashed down upon garlic cloves to remove outer layer"
          use-picture
        >
          <source
            type="image/webp"
            srcset="https://firebasestorage.googleapis.com/v0/b/garlic-rock.appspot.com/o/WebP%2Fsmashing_garlic_demo.webp?alt=media&token=20c2a6c0-c5ea-4cac-85a9-95f803b7945b"
          />
          <source
            type="image/jp2"
            srcset="https://firebasestorage.googleapis.com/v0/b/garlic-rock.appspot.com/o/JPEG2000%2Fsmashing_garlic_demo.jp2?alt=media&token=3cc571c5-fe38-4125-9188-9731eceead36"
          />
        </v-lazy-image>
      </slide>
      <slide>
        <v-lazy-image
          data-src="https://firebasestorage.googleapis.com/v0/b/garlic-rock.appspot.com/o/JPG%2Fsmashed_garlic_demo.jpg?alt=media&token=7c026382-54be-44df-932f-ecada4fdace6"
          alt="Garlic smashed on cutting board ready for easy removal of outer layer"
          use-picture
        >
          <source
            type="image/webp"
            srcset="https://firebasestorage.googleapis.com/v0/b/garlic-rock.appspot.com/o/WebP%2Fsmashed_garlic_demo.webp?alt=media&token=bd2d6664-7f6e-41b8-9d31-2e75468356da"
          />
          <source
            type="image/jp2"
            srcset="https://firebasestorage.googleapis.com/v0/b/garlic-rock.appspot.com/o/JPEG2000%2Fsmashed_garlic_demo.jp2?alt=media&token=7ed919be-d865-493a-8684-307713e6690d"
          />
        </v-lazy-image>
      </slide>
      <slide>
        <v-lazy-image
          data-src="https://firebasestorage.googleapis.com/v0/b/garlic-rock.appspot.com/o/JPG%2Fgrey_rocks.jpg?alt=media&token=7185730f-eedf-4b38-a81a-5ed3395c0901"
          alt="Grey rocks of small, medium and large sizes with Garlic Rock Logo"
          use-picture
        >
          <source
            type="image/webp"
            srcset="https://firebasestorage.googleapis.com/v0/b/garlic-rock.appspot.com/o/WebP%2Fgrey_rocks.webp?alt=media&token=c9f04e4a-0d28-40f6-abe2-1ef957aa5759"
          />
          <source
            type="image/jp2"
            srcset="https://firebasestorage.googleapis.com/v0/b/garlic-rock.appspot.com/o/JPEG2000%2Fgrey_rocks.jp2?alt=media&token=9116bb19-c0b7-49e5-8e5d-116b09fc10c8"
          />
        </v-lazy-image>
      </slide>
      <slide>
        <v-lazy-image
          data-src="https://firebasestorage.googleapis.com/v0/b/garlic-rock.appspot.com/o/JPG%2Fpurple_rocks.jpg?alt=media&token=93583f14-e4b1-4566-a150-8a8606c12c95"
          alt="Purple rocks of small, medium and large sizes with Garlic Rock Logo"
          use-picture
        >
          <source
            type="image/webp"
            srcset="https://firebasestorage.googleapis.com/v0/b/garlic-rock.appspot.com/o/WebP%2Fpurple_rocks.webp?alt=media&token=f826dbaf-a6c6-4b42-bede-c06be898a115"
          />
          <source
            type="image/jp2"
            srcset="https://firebasestorage.googleapis.com/v0/b/garlic-rock.appspot.com/o/JPEG2000%2Fpurple_rocks.jp2?alt=media&token=4bb5a78f-16f0-47a3-a98f-7d3aaaf700c8"
          />
        </v-lazy-image>
      </slide>
      <slide>
        <v-lazy-image
          data-src="https://firebasestorage.googleapis.com/v0/b/garlic-rock.appspot.com/o/JPG%2Fsand_rocks.jpg?alt=media&token=f5af385c-bcff-41f1-85b4-f565cb5218a4"
          alt="Sand colored rocks of small, medium and large sizes with Garlic Rock Logo"
          use-picture
        >
          <source
            type="image/webp"
            srcset="https://firebasestorage.googleapis.com/v0/b/garlic-rock.appspot.com/o/WebP%2Fsand_rocks.webp?alt=media&token=69f0ec08-53d2-436e-b506-3e5ba48f0a74"
          />
          <source
            type="image/jp2"
            srcset="https://firebasestorage.googleapis.com/v0/b/garlic-rock.appspot.com/o/JPEG2000%2Fsand_rocks.jp2?alt=media&token=09858aae-5f47-4355-8a8e-3ecb114d1ad8"
          />
        </v-lazy-image>
      </slide>
    </carousel>
  </div>
</template>

<script>
export default {
  name: 'why',
};
</script>

<style lang="scss" scoped>
@import '../../static/_main';

div,
p {
  font-family: $family-secondary !important;
  font-size: 1.8rem;
  font-weight: 300;
  padding: 1.5rem 0;
  text-align: center;
}

.secondary-font {
  font-family: $family-primary !important;
  font-style: italic;
}

.video {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  width: 100%;
  height: 0;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Why.vue